import { useEffect, useState } from "react";
import { api } from "./shared";

// Loads the signed-in user's latest artist application and says whether
// post-approval pages (edit profile, rights, deactivate) can be used.
export default function useStudioAccount() {
  const [state, setState] = useState({ loading: true, application: null, failed: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await api.get("status");
        if (!cancelled) setState({ loading: false, application: response.data?.result || null, failed: false });
      } catch (e) {
        if (!cancelled) setState({ loading: false, application: null, failed: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const { application } = state;
  return {
    ...state,
    setApplication: (a) => setState((s) => ({ ...s, application: a })),
    isApproved: application?.status === "approved",
    isDeactivated: application?.status === "approved" && application?.account_status === "deactivated",
  };
}
